import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ReportagemAura: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#0a0a0a',
    color: '#222',
    fontFamily: "'Inter', Arial, Helvetica, sans-serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    <main style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }}>
      <div style={{
        maxWidth: 900,
        width: '100%',
        margin: '40px auto',
        background: '#fff',
        padding: 32,
        borderRadius: 8,
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
      }}>
        <h1 style={{ color: '#0a3d62', marginTop: 0 }}>CEARÁ | REPORTAGEM ESPECIAL</h1>
        <div style={{ color: '#888', fontSize: '0.95em', marginBottom: 24 }}>
          Edição nº 87 | Outubro 2025
        </div>
        <h2 style={{ color: '#222', fontWeight: 600, marginBottom: 12 }}>
          Enquanto o mundo fala em carbono neutro, Belém reaprende a contaminar
        </h2>
        <img
          src="/images/accor/lixao-do-aura_.jpg"
          alt="Aterro do Aurá"
          style={{
            width: '100%',
            maxWidth: 700,
            borderRadius: 8,
            margin: '20px 0'
          }}
        />
        <p>
          Às vésperas da COP 30, quando Belém se transforma em vitrine global da sustentabilidade, uma crise ambiental e social se desenrola longe dos holofotes — mas bem perto do nariz de quem vive na periferia. O velho aterro do <b>Aurá</b>, desativado em 2021 por não cumprir normas ambientais, está sendo <b>reativado sob pressão da prefeitura</b>, como se fosse possível reciclar irresponsabilidade.
        </p>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18, marginTop: 32 }}>
          <img
            src="/images/accor/levdescartes.jpg"
            alt="Lev Descartes"
            style={{
              width: 350,
              height: 210,
              objectFit: 'cover',
              borderRadius: '12px',
              border: '1px solid #eee',
              background: '#fafafa',
              flexShrink: 0,
              marginTop: 4
            }}
          />
          <div style={{ flex: 1 }}>
            <h3 style={{ color: '#0a3d62', margin: 0 }}>
              Lev Descartes: o nome por trás do lixo
            </h3>
            <p style={{ marginTop: 10 }}>
              A empresa <b>Lev Descartes</b>, responsável pelo recolhimento de resíduos da rede hoteleira de Belém e também detentora de concessão pública, está despejando lixo de forma irregular no Aurá. A reportagem apurou que o descarte está <b>contaminando o solo e os córregos da região</b>, com impacto direto na saúde da população.
            </p>
            <br></br>
            <blockquote style={{
              borderLeft: '4px solid #0a3d62',
              margin: '16px 0 0 0',
              paddingLeft: 16,
              color: '#444',
              fontStyle: 'italic'
            }}>
              "Minha filha vive com feridas. A água tem cheiro de morte."<br />
              <span style={{ fontWeight: 500 }}>— Dona Maria, moradora do entorno</span>
            </blockquote>
          </div>
        </div>
        <p>
          Mais de <b>50 pessoas já apresentam doenças infecciosas e dermatológicas</b>, segundo levantamento da Secretaria Municipal de Saúde.
        </p>
        <h3 style={{ color: '#0a3d62', marginTop: 32 }}>Trabalho sujo, sem proteção</h3>
        <p>
          Funcionários da Lev Descartes relataram à <b>Ceará</b> que trabalham sem EPIs, sem adicional de insalubridade, sem banheiro, sem água potável. Alguns falam em jornadas de 14 horas. Outros, em ameaças. Todos, em silêncio forçado.
        </p>
        <blockquote style={{
          borderLeft: '4px solid #0a3d62',
          margin: '16px 0',
          paddingLeft: 16,
          color: '#444',
          fontStyle: 'italic'
        }}>
          "A gente trabalha no lixo, sem proteção, sem água, sem nada. E ainda somos ameaçados."<br />
          <span style={{ fontWeight: 500 }}>— Funcionário (identidade preservada)</span>
        </blockquote>
        <p>
          Os indícios apontam para trabalho análogo à escravidão, o que pode configurar crime federal.
        </p>
        <br></br>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18, marginTop: 32 }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ color: '#0a3d62', margin: 0 }}>
              Rede hoteleira: luxo, lixo e selo verde
            </h3>
            <p style={{ marginTop: 10 }}>
              A rede hoteleira envolvida no escândalo cobra diárias abusivas, foi alvo de denúncias junto à Senacom e ostenta, com orgulho, relatórios de sustentabilidade e o selo internacional <b>Green Key</b> — referência em responsabilidade ambiental no turismo.
            </p>
            <blockquote style={{
              borderLeft: '4px solid #0a3d62',
              margin: '16px 0 0 0',
              paddingLeft: 16,
              color: '#444',
              fontStyle: 'italic'
            }}>
              "Como pode um hotel com selo de excelência ambiental contratar uma empresa que despeja lixo tóxico em solo urbano?"<br />
              <span style={{ fontWeight: 500 }}>— Ambientalista ouvido pela reportagem</span>
            </blockquote>
          </div>
          <img
            src="/images/accor/hotel.png"
            alt="Rede Hoteleira"
            style={{
              width: 350,
              height: 210,
              objectFit: 'cover',
              borderRadius: '12px',
              border: '1px solid #eee',
              background: '#fafafa',
              flexShrink: 0,
              marginTop: 4
            }}
          />
        </div>
        <br></br>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18, marginTop: 32 }}>
          <img
            src="/images/accor/cop30.png"
            alt="Lev Descartes"
            style={{
              width: 350,
              height: 210,
              objectFit: 'cover',
              borderRadius: '12px',
              border: '1px solid #eee',
              background: '#fafafa',
              flexShrink: 0,
              marginTop: 4
            }}
          />
          <div style={{ flex: 1 }}>
            <h3 style={{ color: '#0a3d62', margin: 0 }}>
              COP 30: palco ou cortina?
            </h3>
            <p style={{ marginTop: 10 }}>
             Belém se vende como capital da sustentabilidade. Mas a COP 30 corre o risco de se tornar um teatro onde o lixo é varrido para longe das câmeras — e para dentro dos pulmões de quem mora perto do Aurá.
            </p>
            <p>
              Enquanto isso, a Amazônia sangra em silêncio. E o mundo aplaude.
            </p>
          </div>
        </div>
        
        <div style={{
          background: '#eaf6fb',
          borderRadius: 6,
          padding: 18,
          margin: '32px 0',
          color: '#0a3d62',
          fontWeight: 500,
          fontSize: '1.1em'
        }}>
          <b>Ceará segue investigando</b><br />
          Porque o lixo, quando não é reciclado, precisa ser exposto.<br />
          <span style={{ color: '#222', fontWeight: 400 }}>
            Se você vive na região do Aurá e quer compartilhar sua história, envie seu relato para nossa redação:<br />
            <a href="mailto:contato@revistaceará.com.br" style={{ color: '#0077cc' }}>
              contato@revistaceará.com.br
            </a>
          </span>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default ReportagemAura;